
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.997 7.12877L21.9912 7.12412L9.8955 19.5978C9.89533 19.5979 9.89516 19.5981 9.89498 19.5983C9.55692 19.9441 9.10331 20.1353 8.63386 20.1353C8.1647 20.1353 7.71138 19.9444 7.37338 19.5989C7.37299 19.5985 7.3726 19.5982 7.37221 19.5978L1.9906 14.014C1.67063 13.6623 1.49323 13.1931 1.5002 12.7049C1.50719 12.2146 1.69946 11.7495 2.03161 11.4075C2.36329 11.066 2.80783 10.8743 3.26977 10.8681C3.72932 10.862 4.17606 11.0398 4.51535 11.3687L8.27615 15.281L8.63504 15.6543L8.99556 15.2825L19.4429 4.50873L19.0883 4.16485L19.4429 4.50873C19.7806 4.16047 20.2353 3.96777 20.706 3.96777C21.1768 3.96777 21.6315 4.16047 21.9692 4.50873C22.3074 4.85751 22.5 5.33375 22.5 5.83344C22.5 6.31924 22.3179 6.78288 21.997 7.12877Z","fill":"url(#paint0_linear_560_5424)","stroke":"url(#paint1_linear_560_5424)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_560_5424","x1":"12","y1":"3.46777","x2":"12","y2":"20.6353","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#FDD408"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FF928B"}})]),_c('linearGradient',{attrs:{"id":"paint1_linear_560_5424","x1":"12","y1":"3.46777","x2":"12","y2":"20.6353","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#FDD408"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FF928B"}})])])])
          )
        }
      }
    